/*** IMPORTS FROM imports-loader ***/
var define = false;

import init from './common/init'
import finalize from './common/finalize'

export default {

  // JavaScript to be fired on all pages
  init,

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize,
};

